import { createThunkActions } from '../../../utilities';

export const getAnalyticsPriceAddon = createThunkActions('@@addon/GET_ANALYTICS_PRICE_ADDON');
export const getActiveAnalyticsAddon = createThunkActions('@@addon/GET_ACTIVE_ANALYTICS_ADDON');
export const subscribeAnalyticsAddon = createThunkActions('@@addon/SUBSCRIBE_ANAYTICS_ADDON');
export const revokeAnalyticsAddon = createThunkActions('@@addon/REVOKE_ANALYTICS_ADDON');
export const getAllAnalyticsPriceAddon = createThunkActions('@@addon/GET_ALL_ANALYTICS_PRICE_ADDON');
